<div class="relative flex gap-0">
    <aside
        [ngClass]="{
            'w-18 min-w-18': isSidebarCollapsed(),
            'w-56 min-w-56': !isSidebarCollapsed(),
        }"
        class="fixed top-0 bottom-0 left-0 z-50 hidden h-screen overflow-hidden md:block">
        <app-sidebar-client [isCollapsed]="isSidebarCollapsed()" />
    </aside>

    <div
        class="hidden h-screen shrink-0 md:block"
        [ngClass]="{
            'w-18': isSidebarCollapsed(),
            'w-56': !isSidebarCollapsed(),
        }"></div>

    <div
        class="fixed inset-0 z-50 transition-opacity duration-400 md:hidden"
        [ngClass]="{ 'backdrop-blur-[1.5px]': isMobileSidebarOpen }"
        [ngStyle]="{
            'background-color': isMobileSidebarOpen
                ? 'rgba(0, 0, 0, 0.3)'
                : 'transparent',
            'pointer-events': isMobileSidebarOpen ? 'auto' : 'none',
            opacity: isMobileSidebarOpen ? '1' : '0',
        }"
        (click)="closeMobileSidebar()">
        <div
            class="absolute top-0 left-0 h-full w-64 transform bg-gray-50 shadow-lg transition-transform duration-400 ease-in-out"
            [ngClass]="{
                '-translate-x-full': !isMobileSidebarOpen,
                'translate-x-0': isMobileSidebarOpen,
            }">
            <app-sidebar-client [isCollapsed]="false" />
        </div>
    </div>

    <section
        class="bg-color-main flex min-h-screen min-w-0 flex-1 flex-col overflow-hidden">
        <app-header-client-default
            (sidebarToggle)="toggleSidebar()"
            (notificationsClick)="toggleNotifications()"
            [notificationCount]="notificationCount()" />

        <main
            class="bg-color-main animate-fade-in flex-1 overflow-x-hidden p-4 pb-20 md:pb-4">
            <ng-content></ng-content>
        </main>
    </section>

    <app-client-bottom-nav
        class="fixed right-0 bottom-0 left-0 z-[60] md:hidden" />

    @if (showNotifications()) {
        <app-client-notification-drawer
            [notifications]="notifications()"
            (close)="closeNotifications()" />
    }
</div>
